import IconButton from '@mui/material/IconButton';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface NavBtnProps {
	to?: string;
	children: React.ReactNode;
}

const NavBtn = ({ to, children }: NavBtnProps) => {
	const navigate = useNavigate();
	const navBtnFallback = () => {
		const currentURL = window.location.href;
		to ? navigate(to) : navigate(-1);
		const timeout = setTimeout(() => {
			window.location.href === currentURL
				? navigate('/', { replace: true })
				: (() => {})();
			clearTimeout(timeout);
		}, 200);
	};

	return (
		<>
			<IconButton
				onClick={navBtnFallback}
				disableRipple
				sx={{ color: 'primary.main', p: 0 }}
			>
				{children}
			</IconButton>
		</>
	);
};

export default NavBtn;
